module.exports = __webpack_public_path__ + "media/images/1200/CBD_facts_woman_on_bed-faed66da88a6e03257405bf4126d6202.jpg";